import { cn } from '../tokens/cn';
import { cva, focusRing, disabledStyles, transitionBase } from '../tokens/variants';

export const buttonVariants = cva(
  cn(
    'inline-flex items-center justify-center gap-2 font-medium select-none',
    'whitespace-nowrap cursor-pointer',
    focusRing,
    disabledStyles,
    transitionBase,
  ),
  {
    variants: {
      variant: {
        primary: cn(
          'bg-[var(--tk-brand-bg)] text-[var(--tk-brand-fg)]',
          'hover:bg-[var(--tk-brand-bg-hover)] active:bg-[var(--tk-brand-bg-active)]',
        ),
        secondary: cn(
          'bg-[var(--tk-brand-bg-subtle)] text-[var(--tk-brand-fg-on-subtle)]',
          'hover:brightness-95 active:brightness-90',
        ),
        outline: cn(
          'border border-[var(--tk-surface-border-strong)] bg-[var(--tk-surface-bg-elevated)] text-[var(--tk-surface-fg)]',
          'hover:bg-[var(--tk-surface-bg-sunken)]',
        ),
        ghost: cn(
          'bg-transparent text-[var(--tk-surface-fg)]',
          'hover:bg-[var(--tk-surface-bg-elevated)]',
        ),
        link: cn(
          'bg-transparent text-[var(--tk-brand-fg-on-subtle)] underline-offset-4',
          'hover:underline px-0 py-0 h-auto',
        ),
        danger: cn(
          'bg-[var(--tk-danger-bg)] text-[var(--tk-danger-fg)]',
          'hover:brightness-110 active:brightness-95',
        ),
        'danger-ghost': cn(
          'bg-transparent text-[var(--tk-danger-fg-on-subtle)]',
          'hover:bg-[var(--tk-danger-bg-subtle)]',
        ),
      },
      size: {
        sm: 'h-8 px-3 text-sm rounded-tk-md',
        md: 'h-10 px-4 text-sm rounded-tk-md',
        lg: 'h-12 px-5 text-base rounded-tk-lg',
        icon: 'h-10 w-10 rounded-tk-md',
        'icon-sm': 'h-8 w-8 rounded-tk-md',
        'icon-lg': 'h-12 w-12 rounded-tk-lg',
      },
      fullWidth: {
        true: 'w-full',
        false: '',
      },
    },
    compoundVariants: [
      { variant: 'link', size: ['sm', 'md', 'lg'], className: 'h-auto px-0' },
    ],
    defaultVariants: { variant: 'primary', size: 'md', fullWidth: false },
  },
);
